/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_Import_SettingsInputs */

const en_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to import settings`)
};

const fr_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'importation des paramètres`)
};

const de_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen konnten nicht importiert werden`)
};

const it_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile importare le impostazioni`)
};

const ru_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать настройки.`)
};

const es_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al importar la configuración`)
};

const zh_cn2_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置导入失败`)
};

const ja_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定のインポートに失敗しました`)
};

const hi_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स आयात करने में विफल`)
};

const pt_pt2_failed_import_settings = /** @type {(inputs: Failed_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao importar as configurações`)
};

/**
* | output |
* | --- |
* | "Failed to import settings" |
*
* @param {Failed_Import_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_import_settings = /** @type {((inputs?: Failed_Import_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_Import_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed_import_settings(inputs)
	if (locale === "de") return de_failed_import_settings(inputs)
	if (locale === "it") return it_failed_import_settings(inputs)
	if (locale === "ru") return ru_failed_import_settings(inputs)
	if (locale === "es") return es_failed_import_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_failed_import_settings(inputs)
	if (locale === "ja") return ja_failed_import_settings(inputs)
	if (locale === "hi") return hi_failed_import_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_failed_import_settings(inputs)
	return en_failed_import_settings(inputs)
});